"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.oLoginHeader = exports.oLoginContainer = exports.oLoginSection = exports.oLoginChange = void 0;

var _dist = _interopRequireDefault(require("@homepl/onestore-bem/dist"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var oLoginChange = (0, _dist.default)("o-login-change");
exports.oLoginChange = oLoginChange;
var oLoginSection = (0, _dist.default)("o-login-section");
exports.oLoginSection = oLoginSection;
var oLoginContainer = (0, _dist.default)("o-login-container");
exports.oLoginContainer = oLoginContainer;
var oLoginHeader = (0, _dist.default)("o-login-header");
exports.oLoginHeader = oLoginHeader;